import * as React from 'react';
import { Box, Flex, Button, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
import { SubHeading } from 'shared-components/lib/components/atoms/SubHeading';

export interface Props extends React.HTMLProps<HTMLDivElement> {
  id?: string;
  label?: string;
  amount?: string;
  warning?: React.ReactElement | string | null;
  childen?: React.ReactNode;
  canEdit?: boolean;
  edit?: () => void;
}

const ChecklistSection: React.FC<Props> = (props: Props) => {
  const { id = 'section', label, warning, children, canEdit = false, edit, amount } = props;

  return (
    <Box data-selector={id} mb={10}>
      <Flex display="flex" gap={2} data-selector={`${id}-title`} minHeight={8} alignItems="center" flexWrap="wrap">
        {label && (
          <SubHeading data-selector={`${id}-label`} as="h3" mb={2}>
            {label}
          </SubHeading>
        )}

        {amount && (
          <Box data-selector={`${id}-amount`} lineHeight={6}>
            {amount}
          </Box>
        )}

        {canEdit && (
          <Button data-selector={`${id}-edit`} onClick={edit} variant="ghost" size="sm">
            Edit
          </Button>
        )}
      </Flex>

      {warning && (
        <Alert status="warning" data-selector={`${id}-warning`} my={2}>
          <AlertIcon />

          <AlertDescription>{warning}</AlertDescription>
        </Alert>
      )}

      {children}
    </Box>
  );
};

export default ChecklistSection;
